(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-transparent-header]');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initGallery(gallery) {
      var mainImg = gallery.querySelector('.pdp__main-img');
      var thumbs = Array.from(gallery.querySelectorAll('.pdp__thumb-btn'));
      var prevBtn = gallery.querySelector('.pdp__arrow--prev');
      var nextBtn = gallery.querySelector('.pdp__arrow--next');

      if (!mainImg || thumbs.length === 0) return;

      var current = 0;

      function goTo(index) {
        thumbs[current].classList.remove('is-active');
        current = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[current];
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = thumb.dataset.fullSrc;
        mainImg.alt = thumb.dataset.alt || '';
        thumb.classList.add('is-active');
        thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }

    function init() {
      document.querySelectorAll('.pdp__gallery').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
